import { Flex, Typography, Tabs } from "antd";
import { useParams, useNavigate } from "react-router-dom";

import Breadcrumbs from "@/components/ui/Breadcrumbs";

import routes from "@/routes";

import InboxTab from "./InboxTab";
import SettingsTab from "./SettingsTab";
import SubscriprionsTab from "./SubscriptionsTab";

const { Title } = Typography;

const Notices = () => {
  const { tab } = useParams();
  const navigate = useNavigate();

  return (
    <Flex vertical gap={20} className="h-100">
      <Flex vertical gap={12}>
        <Breadcrumbs
          items={[
            {
              title: "Главная",
              href: routes.dashboards,
            },
            {
              title: "Уведомления",
            },
          ]}
        />
        <Title level={2} className="no-margin">
          Уведомления
        </Title>
      </Flex>

      <Tabs
        activeKey={tab || "inbox"}
        items={[
          {
            key: "inbox",
            label: "Лента",
            children: <InboxTab />,
          },
          {
            key: "settings",
            label: "Настройки",
            children: <SettingsTab />,
          },
          {
            key: "subscriptions",
            label: "Подписки",
            children: <SubscriprionsTab />,
          },
        ]}
        onChange={(key) => {
          navigate(routes.notices(key));
        }}
        style={{ flex: 1, minHeight: 0 }}
        className="tabs--h-100"
      />
    </Flex>
  );
};

export default Notices;
